class $b259f53f339e4b20$export$2e2bcd8739ae039 {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    add(v) {
        return new $b259f53f339e4b20$export$2e2bcd8739ae039(this.x + v.x, this.y + v.y);
    }
    addTo(v) {
        this.x += v.x;
        this.y += v.y;
    }
    sub(v) {
        return new $b259f53f339e4b20$export$2e2bcd8739ae039(this.x - v.x, this.y - v.y);
    }
    subFrom(v) {
        this.x -= v.x;
        this.y -= v.y;
    }
    mult(n) {
        return new $b259f53f339e4b20$export$2e2bcd8739ae039(this.x * n, this.y * n);
    }
    div(n) {
        return new $b259f53f339e4b20$export$2e2bcd8739ae039(this.x / n, this.y / n);
    }
    setAngle(angle) {
        var length = this.getLength();
        this.x = Math.cos(angle) * length;
        this.y = Math.sin(angle) * length;
        return this;
    }
    setLength(length) {
        var angle = this.getAngle();
        this.x = Math.cos(angle) * length;
        this.y = Math.sin(angle) * length;
        return this;
    }
    getAngle() {
        return Math.atan2(this.y, this.x);
    }
    getLength() {
        return Math.hypot(this.x, this.y);
    }
    getLengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    distanceTo(v) {
        return this.sub(v).getLength();
    }
    distanceToSq(v) {
        return this.sub(v).getLengthSq();
    }
    copy() {
        return new $b259f53f339e4b20$export$2e2bcd8739ae039(this.x, this.y);
    }
    rotate(angle) {
        return new $b259f53f339e4b20$export$2e2bcd8739ae039(this.x * Math.cos(angle) - this.y * Math.sin(angle), this.x * Math.sin(angle) + this.y * Math.cos(angle));
    }
    rotateAround(v, angle) {
        let x = (this.x - v.x) * Math.cos(angle) - (v.y - this.y) * Math.sin(angle) + v.x;
        let y = (v.y - this.y) * Math.cos(angle) + (this.x - v.x) * Math.sin(angle) + v.y;
        return new $b259f53f339e4b20$export$2e2bcd8739ae039(x, y);
    }
    lerp(v, t) {
        let delta = v.sub(this).mult(t);
        return this.add(delta);
    }
    lerpTo(v, t) {
        let delta = v.sub(this).mult(t);
        this.addTo(delta);
    }
    moveTowards(v, length) {
        let delta = v.sub(this).setLength(length);
        return this.add(delta);
    }
    equals(v) {
        return this.x == v.x && this.y == v.y;
    }
    reflectAlongX() {
        this.y *= -1;
    }
    reflectAlongY() {
        this.x *= -1;
    }
}


class $066d4610ee08afca$export$2e2bcd8739ae039 {
    constructor(a, b, c){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    vertexes() {
        return [
            this.a,
            this.b,
            this.c
        ];
    }
    edges() {
        return [
            [
                this.a,
                this.b
            ],
            [
                this.b,
                this.c
            ],
            [
                this.c,
                this.a
            ]
        ];
    }
    sharesAVertexWith(triangle) {
        for (const v of this.vertexes())for (const vv of triangle.vertexes()){
            if (v.equals(vv)) return true;
        }
        return false;
    }
    hasEdge(edge) {
        for (const e of this.edges()){
            if (e[0].equals(edge[0]) && e[1].equals(edge[1]) || e[1].equals(edge[0]) && e[0].equals(edge[1])) return true;
        }
        return false;
    }
    sharesAnEdgeWith(triangle) {
        for (const edge of triangle.edges()){
            if (this.hasEdge(edge)) return true;
        }
        return false;
    }
    get circumcenter() {
        if (!this._circumcenter) {
            let d = 2 * (this.a.x * (this.b.y - this.c.y) + this.b.x * (this.c.y - this.a.y) + this.c.x * (this.a.y - this.b.y));
            let x = 1 / d * ((this.a.x * this.a.x + this.a.y * this.a.y) * (this.b.y - this.c.y) + (this.b.x * this.b.x + this.b.y * this.b.y) * (this.c.y - this.a.y) + (this.c.x * this.c.x + this.c.y * this.c.y) * (this.a.y - this.b.y));
            let y = 1 / d * ((this.a.x * this.a.x + this.a.y * this.a.y) * (this.c.x - this.b.x) + (this.b.x * this.b.x + this.b.y * this.b.y) * (this.a.x - this.c.x) + (this.c.x * this.c.x + this.c.y * this.c.y) * (this.b.x - this.a.x));
            this._circumcenter = new (0, $b259f53f339e4b20$export$2e2bcd8739ae039)(x, y);
        }
        return this._circumcenter;
    }
    get centroid() {
        if (!this._centroid) this._centroid = this.a.add(this.b).add(this.c).div(3);
        return this._centroid;
    }
    get circumradiusSq() {
        if (!this._circumradiusSq) this._circumradiusSq = this.circumcenter.sub(this.a).getLengthSq();
        return this._circumradiusSq;
    }
    pointIsInsideCircumcircle(point) {
        let dist = point.sub(this.circumcenter).getLengthSq();
        return dist < this.circumradiusSq;
    }
    // Methods below are not needed for Delaunay triangulation, but useful for drawing.
    vertexesAsString() {
        return this.vertexes().map((vertex)=>`${vertex.x}, ${vertex.y}`).join(", ");
    }
    edgeLengths() {
        return this.edges().map((v)=>v[0].sub(v[1]).getLength());
    }
    heights() {
        let [a, b, c] = this.edgeLengths();
        function height(a, b, c) {
            const s = (a + b + c) / 2;
            const h = 2 * Math.sqrt(s * (s - a) * (s - b) * (s - c)) / b;
            return h;
        }
        return [
            height(a, b, c),
            height(b, c, a),
            height(c, a, b)
        ];
    }
    shortestHeight() {
        return Math.min(...this.heights());
    }
}


function $a670ff9246d9bd8a$export$2e2bcd8739ae039(superTriangle, pointList) {
    // pointList is a set of coordinates defining the
    // points to be triangulated
    let triangulation = [];
    // add super-triangle to triangulation
    // must be large enough to completely contain all
    // the points in pointList
    triangulation.push(superTriangle);
    // add all the points one at a time to the triangulation
    pointList.forEach((point)=>{
        let badTriangles = [];
        // first find all the triangles that are no
        // longer valid due to the insertion
        triangulation.forEach((triangle)=>{
            if (triangle.pointIsInsideCircumcircle(point)) badTriangles.push(triangle);
        });
        let polygon = [];
        // find the boundary of the polygonal hole
        badTriangles.forEach((triangle)=>{
            triangle.edges().forEach((edge)=>{
                let edgeIsShared = badTriangles.some((otherTriangle)=>{
                    return triangle !== otherTriangle && otherTriangle.hasEdge(edge);
                });
                if (!edgeIsShared) // edge is not shared by any other
                // triangles in badTriangles
                polygon.push(edge);
            });
        });
        // remove them from the data structure
        badTriangles.forEach((triangle)=>{
            let index = triangulation.indexOf(triangle);
            if (index > -1) triangulation.splice(index, 1);
        });
        // re-triangulate the polygonal hole
        polygon.forEach((edge)=>{
            // form a triangle from edge to point
            let newTri = new (0, $066d4610ee08afca$export$2e2bcd8739ae039)(edge[0], edge[1], point);
            triangulation.push(newTri);
        });
    });
    // done inserting points, now clean up
    let i = triangulation.length;
    while(i--){
        let triangle = triangulation[i];
        if (triangle.sharesAVertexWith(superTriangle)) {
            // remove triangle from triangulation
            let index = triangulation.indexOf(triangle);
            if (index > -1) triangulation.splice(index, 1);
        }
    }
    return triangulation;
}





class $c2455c937b104e74$export$2e2bcd8739ae039 {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    add(v) {
        return new $c2455c937b104e74$export$2e2bcd8739ae039(this.x + v.x, this.y + v.y);
    }
    addTo(v) {
        this.x += v.x;
        this.y += v.y;
    }
    sub(v) {
        return new $c2455c937b104e74$export$2e2bcd8739ae039(this.x - v.x, this.y - v.y);
    }
    subFrom(v) {
        this.x -= v.x;
        this.y -= v.y;
    }
    mult(n) {
        return new $c2455c937b104e74$export$2e2bcd8739ae039(this.x * n, this.y * n);
    }
    div(n) {
        return new $c2455c937b104e74$export$2e2bcd8739ae039(this.x / n, this.y / n);
    }
    setAngle(angle) {
        var length = this.getLength();
        this.x = Math.cos(angle) * length;
        this.y = Math.sin(angle) * length;
        return this;
    }
    setLength(length) {
        var angle = this.getAngle();
        this.x = Math.cos(angle) * length;
        this.y = Math.sin(angle) * length;
        return this;
    }
    getAngle() {
        return Math.atan2(this.y, this.x);
    }
    getLength() {
        return Math.hypot(this.x, this.y);
    }
    getLengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    distanceTo(v) {
        return this.sub(v).getLength();
    }
    distanceToSq(v) {
        return this.sub(v).getLengthSq();
    }
    copy() {
        return new $c2455c937b104e74$export$2e2bcd8739ae039(this.x, this.y);
    }
    rotate(angle) {
        return new $c2455c937b104e74$export$2e2bcd8739ae039(this.x * Math.cos(angle) - this.y * Math.sin(angle), this.x * Math.sin(angle) + this.y * Math.cos(angle));
    }
    rotateAround(v, angle) {
        let x = (this.x - v.x) * Math.cos(angle) - (v.y - this.y) * Math.sin(angle) + v.x;
        let y = (v.y - this.y) * Math.cos(angle) + (this.x - v.x) * Math.sin(angle) + v.y;
        return new $c2455c937b104e74$export$2e2bcd8739ae039(x, y);
    }
    lerp(v, t) {
        let delta = v.sub(this).mult(t);
        return this.add(delta);
    }
    lerpTo(v, t) {
        let delta = v.sub(this).mult(t);
        this.addTo(delta);
    }
    moveTowards(v, length) {
        let delta = v.sub(this).setLength(length);
        return this.add(delta);
    }
    equals(v) {
        return this.x == v.x && this.y == v.y;
    }
    reflectAlongX() {
        this.y *= -1;
    }
    reflectAlongY() {
        this.x *= -1;
    }
}


const $c1ce9d969bfa6909$var$svgNs = "http://www.w3.org/2000/svg";
let $c1ce9d969bfa6909$var$svg;
let $c1ce9d969bfa6909$var$w;
let $c1ce9d969bfa6909$var$h;
function $c1ce9d969bfa6909$var$setup() {
    $c1ce9d969bfa6909$var$svg = document.querySelector("svg");
    document.addEventListener("click", $c1ce9d969bfa6909$var$draw);
    document.addEventListener("keydown", $c1ce9d969bfa6909$var$onKeyDown);
    window.addEventListener("resize", $c1ce9d969bfa6909$var$onResize);
    $c1ce9d969bfa6909$var$onResize();
}
function $c1ce9d969bfa6909$var$onResize() {
    $c1ce9d969bfa6909$var$w = window.innerWidth;
    $c1ce9d969bfa6909$var$h = window.innerHeight;
    $c1ce9d969bfa6909$var$svg.setAttribute("viewBox", `0 0 ${$c1ce9d969bfa6909$var$w} ${$c1ce9d969bfa6909$var$h}`);
    $c1ce9d969bfa6909$var$svg.setAttribute("width", $c1ce9d969bfa6909$var$w.toString());
    $c1ce9d969bfa6909$var$svg.setAttribute("height", $c1ce9d969bfa6909$var$h);
    $c1ce9d969bfa6909$var$draw();
}
function $c1ce9d969bfa6909$var$onKeyDown(e) {
    if (e.code === "KeyD") $c1ce9d969bfa6909$var$download();
}
function $c1ce9d969bfa6909$var$download() {
    let svgDoc = $c1ce9d969bfa6909$var$svg.outerHTML;
    let filename = "delaunay.svg";
    let element = document.createElement("a");
    element.setAttribute("href", "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgDoc));
    element.setAttribute("download", filename);
    element.style.display = "none";
    document.body.appendChild(element);
    element.addEventListener("click", (e)=>e.stopPropagation());
    element.click();
    element.remove();
}
function $c1ce9d969bfa6909$var$getRandomPoints() {
    let pointList = [];
    let div = Math.random() * 12000 + 4000;
    let nrOfPoints = $c1ce9d969bfa6909$var$w * $c1ce9d969bfa6909$var$h / div;
    for(let i = 0; i < nrOfPoints; i++)pointList.push(new (0, $c2455c937b104e74$export$2e2bcd8739ae039)(Math.random() * $c1ce9d969bfa6909$var$w, Math.random() * $c1ce9d969bfa6909$var$h));
    return pointList;
}
function $c1ce9d969bfa6909$var$draw() {
    let group = document.querySelector("g");
    if (group) group.remove();
    group = document.createElementNS($c1ce9d969bfa6909$var$svgNs, "g");
    group.setAttribute("fill", "none");
    group.setAttribute("stroke", "black");
    group.setAttribute("stroke-linecap", "round");
    group.setAttribute("stroke-linejoin", "round");
    let pointList = $c1ce9d969bfa6909$var$getRandomPoints();
    let superTriangle = new (0, $066d4610ee08afca$export$2e2bcd8739ae039)(new (0, $c2455c937b104e74$export$2e2bcd8739ae039)(-$c1ce9d969bfa6909$var$w * 10, $c1ce9d969bfa6909$var$h * 10), new (0, $c2455c937b104e74$export$2e2bcd8739ae039)($c1ce9d969bfa6909$var$w * 10, $c1ce9d969bfa6909$var$h * 10), new (0, $c2455c937b104e74$export$2e2bcd8739ae039)($c1ce9d969bfa6909$var$w / 2, -$c1ce9d969bfa6909$var$h * 10));
    let triangles = (0, $a670ff9246d9bd8a$export$2e2bcd8739ae039)(superTriangle, pointList);
    triangles.forEach((t)=>$c1ce9d969bfa6909$var$drawTriangle(t, group));
    $c1ce9d969bfa6909$var$svg.appendChild(group);
}
function $c1ce9d969bfa6909$var$drawTriangle(triangle, groupElement) {
    let polygon = document.createElementNS($c1ce9d969bfa6909$var$svgNs, "polygon");
    polygon.setAttribute("points", triangle.vertexesAsString());
    groupElement.appendChild(polygon);
    const height = triangle.shortestHeight();
    let nrOfPoints = Math.round(height * 0.25 * (Math.random() * 0.95 + 0.05));
    let points1 = $c1ce9d969bfa6909$var$getPoints(triangle.c, triangle.a, nrOfPoints);
    let points2 = $c1ce9d969bfa6909$var$getPoints(triangle.c, triangle.b, nrOfPoints);
    for(let i = 0; i < nrOfPoints; i++){
        let line = document.createElementNS($c1ce9d969bfa6909$var$svgNs, "line");
        line.setAttribute("x1", points1[i].x);
        line.setAttribute("y1", points1[i].y);
        line.setAttribute("x2", points2[i].x);
        line.setAttribute("y2", points2[i].y);
        groupElement.appendChild(line);
    }
}
function $c1ce9d969bfa6909$var$getPoints(p1, p2, nrOfPoints) {
    let points = [];
    let delta = p1.sub(p2).div(nrOfPoints + 1);
    for(let i = 1; i < nrOfPoints + 1; i++){
        let currentPos = p2.add(delta.mult(i));
        points.push(currentPos);
    }
    return points;
}
$c1ce9d969bfa6909$var$setup();


//# sourceMappingURL=striped-triangles-pattern.6ad9c2b2.js.map
